import { SpinResponse, SpecialSymbolGroup } from '@cgs/data-access';

export abstract class GameComponentProvider {
  public getSpecSymbolGroupsByMarker(
    response: SpinResponse,
    marker: string
  ): SpecialSymbolGroup[] | null {
    const symbols = response.specialSymbolGroups;
    return symbols ? symbols.filter((p) => p.type === marker) : null;
  }

  public initialize(): void {}
  public deinitialize(): void {}
}
